/** @jsxImportSource theme-ui */
import React from "react"
import { jsx } from "theme-ui"
import { Grid } from "@theme-ui/components"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage } from 'gatsby-plugin-image';

const SocialProof = props => {
  const { indCustomers, meCustomers } = useStaticQuery(graphql`
		query SocialProof {
			indCustomers: allDatoCmsCustomer(
				filter: {
					enabled: { eq: true }
					customerType: { eq: "awesome_customers" }
					region: { regex: "/india/" }
				}
			) {
				nodes {
					companyLogo {
						gatsbyImageData(
							width: 180
							height: 70
							layout: CONSTRAINED
						)
					}
					companyLogoAltText
					companyLogoTitle
				}
			}
			meCustomers: allDatoCmsCustomer(
				filter: {
					enabled: { eq: true }
					customerType: { eq: "awesome_customers" }
					region: { regex: "/middle-east/" }
				}
			) {
				nodes {
					companyLogo {
						gatsbyImageData(
							width: 180
							height: 70
							layout: CONSTRAINED
						)
					}
					companyLogoAltText
				}
			}
		}
	`);

	return (
		<Grid
		  sx={{
			gridTemplateColumns: [
			  "repeat(2, 1fr)",
			  "repeat(2, 1fr)",
			  "repeat(3, 1fr)",
			  "repeat(5, 1fr)",
			],
			gap: "3rem",
		  }}
		>
		  {props.region === "india" || props.region === "IN"
			? indCustomers.nodes.map(
				({ companyLogo, companyLogoAltText }, index) => companyLogo && (
				  <GatsbyImage
					key={`ind-customer-${index}`}
					image={companyLogo?.gatsbyImageData}
					imgStyle={{ width: "100%", height: "100%", objectFit: "contain" }}
					alt={companyLogoAltText}
				  />
				),
			  )
			: meCustomers.nodes.map(({ companyLogo, companyLogoAltText }, index) => companyLogo && (
				<GatsbyImage
				  key={`me-customer-${index}`}
				  image={companyLogo?.gatsbyImageData}
				  imgStyle={{ width: "100%", height: "100%", objectFit: "contain" }}
				  alt={companyLogoAltText}
				/>
			  ))}
		</Grid>
	  );
	  
}

SocialProof.defaultProps = {
  region: "IN"
}

export default SocialProof
